export * from './ErrorPageWithImage'
